import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserData } from '../../services/useUserData';
import { useAppStore } from '../../store/useAppStore';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import { apiService } from '../../services/api_url';
import Loader from '../../widgets/Loader/Loader';
import { BackIcon } from '../../assets/images/BackIcon';
import { CheckIcon, CloseIcon } from '../../assets/images/ReferralIcons';

import './AddEmailPage.scss';

const AddEmailPage: React.FC = () => {
    const navigate = useNavigate();
    const { telegramId, loading: userLoading } = useUserData();
    const { updateUserEmail } = useAppStore();


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        // Валидация
        if (!email || !password) {
            setError('Заполните все поля');
            return;
        }

        if (password !== confirmPassword) {
            setError('Пароли не совпадают');
            return;
        }

        if (password.length < 6) {
            setError('Пароль должен содержать минимум 6 символов');
            return;
        }

        // Валидация email
        const emailRegex = /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Введите корректный email адрес');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${apiService.getBaseURL()}/user/add-email-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    telegram_id: telegramId,
                    email: email.trim(),
                    password: password
                })
            });

            const data = await response.json();

            if (data.success) {

                updateUserEmail(email.trim());

                setSuccess(true);
                setTimeout(() => {
                    navigate('/profile');
                }, 2000);
            } else {
                setError(data.message || 'Ошибка при сохранении');
            }
        } catch (err) {
            setError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    if (userLoading) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar />
                <div className="add-email-page loading">
                    <div className="loader"><Loader /></div>
                </div>
            </div>
        );
    }

    if (!telegramId) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar />
                <div className="add-email-page">
                    <div className="add-email-header">
                        <button className="back-button" onClick={() => navigate(-1)}>
                            <BackIcon />
                        </button>
                        <div className="add-email-title">Добавление email</div>
                    </div>
                    <div className="error-container">
                        <div className="error-icon">🔒</div>
                        <h2>Необходима авторизация</h2>
                        <p>Для добавления email нужно войти в систему</p>
                        <button className="continue-button" onClick={() => navigate('/key')}>
                            Перейти к авторизации
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="add-email-page">
                <div className="add-email-header">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        <BackIcon />
                    </button>
                    <div className="add-email-title">Добавление email и пароля</div>
                </div>

                {error && (
                    <div className="error-message">
                        <CloseIcon />
                        <span>{error}</span>
                    </div>
                )}

                {success ? (
                    <div className="success-message detailed">
                        <div className="success-icon-large">
                            <CheckIcon />
                        </div>
                        <div className="success-content">
                            <div className="success-title">Успешно!</div>
                            <div className="success-details">
                                <div className="detail-row">
                                    <span className="detail-label">Email:</span>
                                    <span className="detail-value">{email}</span>
                                </div>
                            </div>
                            <p className="success-note">Перенаправление в профиль...</p>
                        </div>
                    </div>
                ) : (
                    <div className="form-card">
                        <p className="form-subtitle">
                            Это позволит вам входить в личный кабинет используя email и пароль
                        </p>

                        <form onSubmit={handleSubmit} className="email-form">
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="example@mail.com"
                                    disabled={loading}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">Пароль</label>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Минимум 6 символов"
                                    disabled={loading}
                                    autoComplete="new-password"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirmPassword">Подтвердите пароль</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Повторите пароль"
                                    disabled={loading}
                                    autoComplete="new-password"
                                />
                            </div>

                            <button
                                type="submit"
                                className="submit-button"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="loader-spinner"></span>
                                        Сохранение...
                                    </>
                                ) : (
                                    'Сохранить'
                                )}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddEmailPage;